<template>
	<div class="pageSetting-body">
		<div class="fx-header">
			<p>首页装修方案</p>
		</div>
		<div class="body-box">
			<div class="input-box">
				<span>方案名称：</span>
				<el-input
					class="search-input"
					v-model="pageName"
					placeholder="请输入方案名称"
					size="small"
					clearable
					@keyup.enter.native="search">
				</el-input>
				<el-button type="primary" size="mini" class="btn" @click="search">查询</el-button>
			</div>
			<div class="customList-btn-box">
				<el-button type="primary" size="mini" v-if="AuthorityList['16_0003_0003_00']" class="btn" @click="addClick">新建</el-button>
				<el-button type="primary" size="mini" v-if="AuthorityList['16_0003_0004_00']" class="btn" @click="delListClick">删除</el-button>
			</div>
			<div class="main-table-box">
				<div style="flex: 1">
					<el-table
					class="grid-content"
					:data="tableData"
					border
					stripe
					@selection-change="selectionChangeHandle"
					ref="table"
					height="100%"
					>
						<el-table-column
							type="selection"
							align="center"
							width="50">
						</el-table-column>
						<el-table-column
							prop="styleName"
							label="方案名称"
							align="center">
						</el-table-column>
						<el-table-column
							prop="createdate"
							label="创建时间"
							align="center">
						</el-table-column>
						<el-table-column
							prop="relAllShopFlag"
							label="关联店铺"
							align="center">
							<template slot-scope="scope">
								<div class="table-shop" @click="setShop(scope.row)" v-if="scope.row.relAllShopFlag === 1">全部</div>
								<div class="table-shop" @click="setShop(scope.row)" :title="scope.row.shopNames" v-else>{{`${scope.row.shopCount}家`}}</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="220" align="center">
							<template slot-scope="scope">
								<el-button v-if="AuthorityList['16_0003_0002_00']" type='text' size="mini" @click="rowClick(scope.row)">编辑</el-button>
								<el-button v-if="AuthorityList['16_0003_0004_00']"  type='text' size="mini" @click="delClick(scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handlePageChange"
						:current-page="page"
						:page-sizes="[20,40, 60, 100]"
						:page-size="size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="totalCount">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog
			title="选择关联店铺"
			:visible.sync="bindingModal"
			:close-on-click-modal="false"
			class="img-dialog"
			width="500px"
			append-to-body>
			<div style="text-align: center">
				<div>
					<div style="display: flex;align-items: center;height: 40px;">
						<div style="width:90px;text-align: right;">
							适用门店：
						</div>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="1">全部门店</el-radio>
						<el-radio style="min-height: 40px;;line-height: 40px;" v-model="shopattendway" :label="0">自定义门店</el-radio>
						<div  v-if="shopattendway === 0" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择门店
						</div>
					</div>
					<div v-if="shopattendway === 0" style="display: flex;align-items: center;min-height: 40px;">
						<div style="width:90px;text-align: right;flex-shrink: 0;">
							已选：
						</div>
						<div>{{shopText}}</div>
					</div>
				</div>
				<div style="text-align: center;margin-top: 20px">
					<el-button class="btn" size="small" plain type="primary" @click="closeBind">取消</el-button>
					<el-button class="btn" size="small" plain type="primary" @click="saveBind">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="错误信息提示"
			class="dialog-title"
			:visible.sync="errorDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div class="error-box">
				<div v-for="item in errorList" :key="item">{{item}}</div>
			</div>
			<div style="text-align: center;margin-top: 20px">
				<el-button class="btn" size="small" plain type="primary" @click="errorDialog = false">确认</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'homepageList',
	components: {
		bindShop
	},
	data () {
		return {
			ids: [],
			pageName: '',
			page: 1,
			size: 20,
			totalCount: 0,
			tableData: [],
			AuthorityList: {
				'16_0003_0001_00': false,
				'16_0003_0002_00': false,
				'16_0003_0003_00': false,
				'16_0003_0004_00': false
			},
			bindingModal: false,
			shopattendway: 0,
			shopDialog: false,
			shopText: '',
			chooseShop: [],
			shopList: [],
			styleid: '',
			errorDialog: false,
			errorList: []
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '15-4')
		this.getAuthority('16_0003_0000_00')
		this.getList()
	},
	methods: {
		setShop (row) {
			this.shopattendway = row.relAllShopFlag
			this.chooseShop = row.shopIds
			this.shopText = row.shopNames
			this.styleid = row.id
			this.bindingModal = true
		},
		closeBind () {
			this.bindingModal = false
		},
		saveBind () {
			if (this.shopattendway === 0 && this.chooseShop.length === 0) {
				this.$message.error('请选择关联店铺！')
				return false
			}
			let params = {
				styleid: this.styleid,
				relAllShopFlag: this.shopattendway,
				shopIds: this.chooseShop
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/style/saveRelShop`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功!')
					this.getList()
				} else {
					this.errorList = res.data
					this.errorDialog = true
				}
			})
			this.bindingModal = false
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		addClick () {
			this.$router.push({ path: '/main/homepageSetting' })
		},
		delClick (row) {
			this.$confirm(`是否确定删除方案？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let msg = '删除首页装修方案，方案名称：' + row.styleName
				let url = window.location.href.split('?')[0]
				url = url.replace(window.location.origin, '').substring(1)
				let param = {
					styleids: row.id,
					logMessage: {
						message: msg,
						referer: url
					}
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/style/del`,
					data: param
				}).then(res => {
					if (res.result) {
						this.$message.success(res.msg)
						this.getList()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		delListClick () {
			if (this.ids.length === 0) {
				this.$message.error('请至少选择一个方案')
				return false
			}
			this.$confirm(`是否确定删除已选方案？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let idArr = []
				let nameArr = []
				this.ids.forEach(item => {
					idArr.push(item.id)
					nameArr.push(item.styleName)
				})
				let msg = '删除首页装修方案，方案名称：' + nameArr.join(',')
				let url = window.location.href.split('?')[0]
				url = url.replace(window.location.origin, '').substring(1)
				let param = {
					styleids: idArr.join(','),
					logMessage: {
						message: msg,
						referer: url
					}
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/style/del`,
					data: param
				}).then(res => {
					if (res.result) {
						this.$message.success(res.msg)
						this.getList()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		selectionChangeHandle (value) {
			this.ids = value
		},
		rowClick (item) {
			// window.sessionStorage.setItem('customPageId', item.id)
			this.$router.push({ path: '/main/homepageSetting', query: { id: item.id } })
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.getList()
		},
		handlePageChange (value) {
			this.page = value
			this.getList()
		},
		getList () {
			let params = {
				styleType: 0,
				styleName: this.pageName,
				page: this.page,
				size: this.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/style/list`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				this.totalCount = res.recordCount
			})
		},
		search () {
			this.page = 1
			this.size = 20
			this.getList()
		}
	}
}
</script>

<style lang="stylus" scoped>
.pageSetting-body{
	flex: 1
	display flex
	flex-direction column
	.body-box{
		flex: 1
		flex-direction:column;
		display: flex;
		width :100%;
		padding-bottom :10px
	}
	.customList-btn-box{
		margin-bottom: 20px
		text-align: left;
	}
	.main-table-box{
		flex: 1;
		flex-direction: column;
		display: flex
		.table-shop {
			cursor: pointer
			color: var(--fx-primary-color);
			text-decoration: underline;
		}
	}
	.input-box {
		display: flex
		align-items: center;
		padding: 20px 0;
	}
	.el-input {
		width: 200px
	}
	.btn {
		margin-left: 5px
	}
	.pagination{
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center
	}
}

</style>
<style lang="stylus">
	.error-box {
		line-height: 30px;
		max-height: 400px;
		overflow-y: auto
	}
</style>

